module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }